import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-screen",
  "use": "icon-screen-usage",
  "viewBox": "0 0 1152 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1152 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-screen\"><path d=\"M128 0C57.4 0 0 57.4 0 128v576c0 70.6 57.4 128 128 128h352l-21.4 64H320c-35.4 0-64 28.6-64 64s28.6 64 64 64h512c35.4 0 64-28.6 64-64s-28.6-64-64-64h-138.6L672 832h352c70.6 0 128-57.4 128-128V128c0-70.6-57.4-128-128-128H128z m896 128v448H128V128h896z\" p-id=\"17052\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol